import React from 'react';

import { Typography } from '@mui/material';

import type { MenuDayDataDto, MenuDayItemDto } from '@core/interfaces/api';

import { sanitizeMenuItems } from './menu-item-utils';
import { MenuMeal } from './menu-meal';

interface MenuRowExpandedContentProps {
  data: MenuDayDataDto;
  showSnacks?: boolean;
}

function MenuRowExpandedContent({
  data,
  showSnacks = false,
}: MenuRowExpandedContentProps) {
  const meals = showSnacks
    ? [
        {
          title: 'Breakfast',
          items: (data.BreakfastItems || []) as MenuDayItemDto[],
        },
        { title: 'Lunch', items: (data.LunchItems || []) as MenuDayItemDto[] },
        {
          title: 'Dinner',
          items: (data.DinnerItems || []) as MenuDayItemDto[],
        },
        {
          title: 'Morning Snack',
          items: (data.MorningSnacks || []) as MenuDayItemDto[],
        },
        {
          title: 'Afternoon Snack',
          items: (data.AfternoonSnacks || []) as MenuDayItemDto[],
        },
        {
          title: 'Evening Snack',
          items: (data.EveningSnacks || []) as MenuDayItemDto[],
        },
      ]
    : [
        {
          title: 'Breakfast',
          items: (data.BreakfastItems || []) as MenuDayItemDto[],
        },
        {
          title: 'Lunch',
          items: (data.LunchItems || []) as MenuDayItemDto[],
        },
        {
          title: 'Dinner',
          items: (data.DinnerItems || []) as MenuDayItemDto[],
        },
      ];

  const visibleMeals = meals.filter(
    (meal) => sanitizeMenuItems(meal.items).length > 0,
  );

  if (!visibleMeals.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No menu items provided for this day.
      </Typography>
    );
  }

  const gridCols =
    {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      5: 'grid-cols-5',
      6: 'grid-cols-6',
    }[visibleMeals.length] || 'grid-cols-6';

  return (
    <div className={`grid ${gridCols} gap-4`}>
      {visibleMeals.map((meal) => (
        <MenuMeal key={meal.title} title={meal.title} items={meal.items} />
      ))}
    </div>
  );
}

export { MenuRowExpandedContent, type MenuRowExpandedContentProps };
